import { useState, useEffect } from 'react';
import { Bookmark } from 'lucide-react';
import { getBookmarks, toggleBookmark } from '../../services/bookmarks';

export default function Bookmarks() {
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBookmarks().then(r => setBookmarks(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleRemove = async (lessonId, id) => {
    await toggleBookmark(lessonId);
    setBookmarks(prev => prev.filter(b => b.id !== id));
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2"><Bookmark className="w-6 h-6" /> Saqlanganlar</h1>
      {bookmarks.length > 0 ? bookmarks.map(b => (
        <div key={b.id} className="bg-white rounded-xl p-4 border border-gray-100 flex items-center justify-between">
          <div>
            <h3 className="font-medium text-gray-900">{b.lesson?.title || 'Dars'}</h3>
            <p className="text-xs text-gray-500 mt-1">{new Date(b.created_at).toLocaleDateString('uz')}</p>
          </div>
          <button onClick={() => handleRemove(b.lesson_id, b.id)} className="text-red-400 hover:text-red-600 text-sm">O'chirish</button>
        </div>
      )) : (
        <div className="bg-white rounded-2xl p-12 text-center border border-gray-100">
          <div className="mb-4 flex justify-center"><Bookmark className="w-12 h-12 text-gray-300" /></div>
          <p className="text-gray-500">Saqlanganlar bo'sh</p>
        </div>
      )}
    </div>
  );
}